module.exports = __webpack_public_path__ + "static/img/2-bai.5da80e44.png";